module.exports = __webpack_public_path__ + "static/media/thum_3.2133da4b.jpg";